import React from 'react';
import ReactDOM from 'react-dom';
import App from './Routes';
import reportWebVitals from './reportWebVitals';

import './style/style.scss';
import './style/all.min.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('body')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
console.info(`
     /\\
 )  ( ')
 (  / \\)
  \\(_)_\\
 ClaCloud`);
